import React from 'react'
import { AccountsLayout } from '../components/layout'
import { InputField } from 'cwp-components/forms'
import { BsInfoCircleFill } from 'react-icons/bs'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

const SolicitorCreation = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    trigger,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const onSubmit = () => {
    navigate('/accounts/solicitor/details')
  }

  return (
    <AccountsLayout>
      <div className='relative !m-auto md:p-[60px] bg-white rounded-[20px] shadow-[-0.8px_-0.8px_16px_0px_rgba(0,0,0,0.25)]'>
        <h1 className='mb-[48px] font-bold text-[24px] '>Profile creation</h1>
        <form onSubmit={handleSubmit(onSubmit)} className='grid grid-cols-1'>
          <div className='flex flex-col item-center space-y-[12px] mb-[26px]'>
            <InputField
              register={register}
              required={true}
              id='entityId'
              label='SRA entity ID'
              placeholder='entityId'
              className='h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
            <p className='text-[#37455C] md:w-[407px] text-[10px] flex items-start gap-[6px]'>
              <BsInfoCircleFill />
              This is the assigned SRA ID number to the law firm or entity you
              are associating your profile to.
            </p>
          </div>

          <div className='flex justify-end'>
            <button className='btn btn-default'>Continue</button>
          </div>
        </form>
      </div>
    </AccountsLayout>
  )
}

export default SolicitorCreation
